<template>
  <section>
    <div
      ref="searchMemberBox"
      class="search-member-box"
    >
      <div
        v-ie-placeholder
        :class="['user-tag', {'active': focus},limit>0&&selected.length>=limit?'input-error':'']"
      >
        <span
          v-for="(user,index) in selected"
          :key="index"
          class="selected-user"
          :class="{'email-error': user.error}"
        >
          {{ user.name }}
          <span
            class="del-selected-user"
            @click="rmMember(index,user.id)"
          ><i
            style="margin-left:12px;margin-bottom: 6px;"
            class="el-icon-close"
          /></span>
        </span>
        <input
          v-show="showSearchInput"
          v-model="searchMemberParams.keyword"
          class="user-info-input"
          type="text"
          :placeholder="selected.length ===0 ? this.$t(placeholder) : ''"
          :disabled="disable"
          @focus="showList()"
          @keyup="searchMember($event)"
          @keydown="deletselect($event)"
        >
      </div>
      <p
        v-if="limit>0&&selected.length>=limit"
        class="error"
      >
        {{ '最多可输入最多'+limit+'个邮箱地址' }}
      </p>
      <ul
        v-show="menuShow && creator.length!==0"
        ref="memberList"
        class="member-list"
        :style="{top:toBottom,height:keywordLen===0?'220px':'auto',padding:keywordLen===0?'':'10px 0'}"
      >
        <ul
          v-if="this.type == 'email' && historyEmail&& historyEmail.length>0&&keywordLen===0"
          class="history-box"
        >
          <span class="item-member-title">
            <span class="history-word">{{ $t('历史记录') }}</span>
            <span
              class="clear"
              @click="clearRecent"
            >{{ $t('清空历史') }}</span>
          </span>
          <li
            v-for="(item, index) in historyEmail"
            :key="index"
            class="item-member"
            @mousedown="selectMember($event,{email:item, id: index})"
          >
            <span
              class="select-box box-checkbox-inner"
              :class="(selectedList[index]? 'checkbox-checked': '')"
            />
            <!-- <i class="select-box"
                           :class="(selectedList[index]? 'checkbox-checked': '')"></i> -->
            <!--<span class="user-name" :title="item">{{item}}</span>-->
            <span
              class="user-email"
              :title="item"
            >{{ item }}</span>
          </li>
        </ul>
        <span
          v-if="this.type == 'email'&&keywordLen===0"
          class="item-member-title"
        >
          <span class="box-colleague-word">{{ $t('网盘同事') }}</span>
        </span>
        <li
          v-if="creator.length==0"
          class="item-member"
        >
          {{ $t('无相关搜索结果') }}
        </li>
        <li
          v-for="(item, index) in creator"
          v-else
          :id="item.uid"
          :key="index"
          class="item-member"
          @mousedown="selectMember($event,item)"
        >
          <span
            v-if="!single"
            class="select-box box-checkbox-inner"
            :class="(selectedList[item.id]? 'checkbox-checked': '')"
          />
          <!-- <i v-if="!single" class="select-box"
                       :class="(selectedList[item.id]? 'checkbox-checked': '')"></i> -->
          <span
            class="user-name"
            :title="item.user_name"
          >{{ item.user_name }}</span>
          <span
            class="user-email"
            :title="item.email"
          >{{ item.email }}</span>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>

import * as Util from 'js/util/util'
import store from 'store'
import Cookie from 'js/lib/cookie.js'

const { getData } = require('js/api/getdata').default

export default {
  // @single boolean 是否为单选， @type string 选中后显示类型 name或email, @position 弹出框相对input的位置 参数top或null
  props: {
    single: {
      type: Boolean,
    },
    type: {
      type: String,
    },
    position: {
      type: String,
    },
    disable: {
      type: Boolean, // 表示不可编辑状态
    },
    value: {
      type: Array,
    },
    focusShow: {
      type: Boolean, // 是否点击之后就显示列表
      default: true,
    },
    placeholder: {
      type: String, // 是否点击之后就显示列表
      default: '按照文件创建者搜索',
    },
    limit: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      creator: [],
      selected: [],
      selectedList: {},
      showSearchInput: true,
      menuShow: false,
      creator_id: '',
      toBottom: '',
      searchMemberParams: {
        keyword: [],
        page_num: '',
        num_each_page: '',
        type: 'user',
        _: Date.parse(new Date()),
        account_id: 171,
        uid: '',
      },
      focus: false, // 用于控制样式，focus时边变蓝
      historyEmail: '',
    }
  },
  computed: {
    keywordLen() {
      return this.searchMemberParams.keyword.length
    },
  },
  watch: {
    value(val) {
      this.selected = val
      if (!val.length) this.showSearchInput = true
    },
    focus(val) {
      if (!val) this.menuShow = false
      this.historyEmail = Array.from(new Set(Cookie.get('querymails') ? Cookie.get('querymails').split(';') : null))
    },
    type(val) {
      if (val == 'email') this.toBottom = '-220px'
    },
    keywordLen(val) {
      this.calculateMenuHeight()
    },
    menuShow(val) {
      // 注册监听body click事件 点击除该组件内的情况外 hide该组件
      if (val) {
        document.addEventListener('click', this.hidePanel, true)
      } else {
        document.removeEventListener('click', this.hidePanel, true)
      }
    },
  },
  mounted() {
    this.searchMemberParams.uid = store.getters.uId
  },
  methods: {
    rmMember(index, id) {
      this.selected.splice(index, 1)
      this.selectedList[id] = false
      this.showSearchInput = true
    },
    saveRecent(email) {
      const oval = Cookie.get('querymails'); let
        nval = []
      if (!oval) {
        nval = email
      } else {
        nval = (`${oval};${email}`).replace(';;', ';')
      }
      nval = email.indexOf(';') > -1 ? nval.split(';') : email

      if (nval instanceof Array) nval.pop()

      nval = nval.length > 5 ? nval.slice(-5) : nval
      Cookie.set('querymails', nval.join(';'), { path: '/' })
    },
    selectMember(e, i) {
      this.$emit('watchSelected')
      if (this.type == 'name') {
        this.showSearchInput = false
        this.menuShow = false
        this.selected.push({ name: i.user_name, id: i.id })
      } else {
        this.selectedList[i.id] = !this.selectedList[i.id]

        if (this.selectedList[i.id] == false) {
          for (let k = 0; k < this.selected.length; k++) {
            if (this.selected[k].id == i.id) {
              this.selected.splice(k, 1)
              return
            }
          }
        }

        if (JSON.stringify(this.selected).indexOf(i.email) > -1) {
          this.selectedList[i.id] = !this.selectedList[i.id]
          return // 存在相同项则返回
        }

        this.selected.push({ name: i.email, id: i.id })
      }
      const selectedEmail = []
      for (let i = 0, len = this.selected.length; i < len; i++) {
        selectedEmail.push(this.selected[i].name)
      }
      // 通过v-model双向绑定，将选中的数据传给父组件
      this.$emit('input', this.selected)
    },
    showList() {
      this.focus = true
      if (!this.focusShow) return
      this.searchMemberParams.keyword = this.searchMemberParams.keyword.length > 0 ? this.searchMemberParams.keyword : ''
      this.searchMember()
      if (this.type == 'email') this.menuShow = true
    },
    hideList() {
      this.clearKeyWords()
      this.menuShow = false
    },
    clearKeyWords() {
      this.focus = false
      this.searchMemberParams.keyword = ''
    },
    deletselect(e) {
      if (this.type !== 'email') return

      this.$emit('watchSelected')

      if (this.searchMemberParams.keyword.length > 0) this.showList()// 显示搜索列表

      if (e.keyCode == 8 && this.searchMemberParams.keyword.length < 1) { // 删除标签
        const index = this.selected.length - 1
        if (this.selected.length > 0) this.rmMember(index, this.selected[index].id)
        this.hideList()
      }
    },
    clearRecent() {
      Cookie.set('querymails', '', { path: '/' })
      this.historyEmail = ''
    },
    searchMember(e) {
      let value = this.searchMemberParams.keyword
      if (value.indexOf(';') > -1 || value.indexOf(',') > -1) {
        value = value.replace(',', '').replace(';', '').trim()
        if ((e.keyCode == 188 || e.keyCode == 186 || e.keyCode == 32) && value.length > 0) {
          if (JSON.stringify(this.selected).indexOf(value) > -1) {
            this.searchMemberParams.keyword = ''
            return// 存在相同项则返回
          }

          if (!Util.validEmail(value) && this.type === 'email') {
            this.selected.push({ name: value, error: true })
            window.$toast.simpleShow(this.$t('以下标红的邮箱格式不正确，检查一下吧'), 'warn')
          } else {
            this.selected.push({ name: value })
            // 解决输入外部邮箱也能存入历史记录
            this.saveRecent(`${value};`)
          }
          this.searchMemberParams.keyword = ''
          this.hideList()
          return
        }
      }


      let getUserList = ''
      clearTimeout(getUserList)
      getUserList = setTimeout(() => {
        getData('userTeamSearch', this.searchMemberParams).then((res) => {
          if (res.status == 200) {
            this.creator = res.data.content
            this.menuShow = true
            this.calculateMenuHeight()
          } else {
            console.log(res.message)
          }
        })
      }, 300)
    },
    /**
             * @description 动态计算弹出菜单的高度
             */
    calculateMenuHeight() {
      this.$nextTick(() => {
        if (this.position == 'top') {
          const memberListHeight = Util.getWidthOrHeight(this.$refs.memberList, 'height')
          this.toBottom = `-${memberListHeight === 0 ? 300 + 5 : memberListHeight + 5}px`
        }
      })
    },
    /**
             * @description 点击组件以外的地方 hide
             */
    hidePanel(e) {
      if (!this.$refs.searchMemberBox.contains(e.target)) {
        this.menuShow = false
      }
    },
  },
}
</script>
<style lang="less">
@import '~less/variable.less';
@import '~less/file.less';

.search-member-box {
  position: relative;
  font-size: @littleFontSize;
  input, span {
    font-size: @littleFontSize;
    vertical-align: middle;
  }
  .input-error{
    border: 1px solid #FF3D3C;
    border-radius: 2px;
  }
  .active {
    border: 1px solid @mainColor;
  }
  .error{
    font-size: 14px;
    color: #FF3D3C;
    margin-top: 8px;
  }
}

.member-list {
  position: absolute;
  background: #fff;
  border: 1px solid @border;
  border-radius: 2px;
  width: 99%;
  z-index: 3;
  color: #575757;
  box-shadow: 7px 8px 5px hsla(0,0%,77.3%,.5);
  max-height: 220px;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 40px;
  .history-box{
    .item-member{
      width: 100%;
      display: inline-block;
      box-sizing: border-box;
      padding: 0 16px;
      height: 26px;
      line-height: 26px;
      text-align: left;
      .user-email{
        padding-left: 10px;
      }
    }
  }
  .item-member-title{
    box-sizing: border-box;
    width:100%;
    margin-bottom: 12px;
    display: inline-block;
    .history-word{
      display:inline-block;
      padding:12px 0 0 16px;
      font-size: 14px;
      color: #637282;
    }
    .clear{
      padding:12px 16px 0 0;
      float: right;
      cursor: pointer;
      font-size: 14px;
      color: #929CA9;
    }
    .box-colleague-word{
      display:inline-block;
      padding:16px 0 0 16px;
      font-size: 14px;
      color: #637282;
    }
  }
}

.member-list::-webkit-scrollbar, .user-tag::-webkit-scrollbar {
  width: 6px;
  height: 4px;
}

.member-list::-webkit-scrollbar-thumb, .user-tag::-webkit-scrollbar-thumb {
  opacity: 0.6;
  background: #c1c7cd ;
  border-radius: 100px;
}

.member-list > li {
  padding: 0 16px;
  height: 26px;
  line-height: 26px;
  text-align: left;
  .user-email {
    display: inline-block;
  }
}

.member-list .user-name {
  .nowrap();
  width: 25%;
  float: left;
  text-align: left;
  padding-left: 10px;
}

.select-box {
  float: left;
  line-height: 26px;
  margin-top: 6px;
}

.user-email {
  .nowrap();
  width: 63%;
}

.nowrap() {
  width: 196px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}


.member-list > li:hover {
  background: #e7f0ff;
}

.user-tag {
  text-align: left;
  border: 1px solid @border;
  border-radius: 2px;
  box-sizing: border-box;
  height: auto;
  max-height: 120px;
  min-height: 34px;
  /*padding: 0 8px;*/
  width: 100%;
  line-height: 34px;
  overflow-y: auto;
  padding: 0 12px;
  border-color: #c6cdd7;
}

.selected-user {
  background-color: #EEEEEE;
  padding: 0 5px;
  border-radius: 2px;
  height: 24px;
  line-height: 24px;
  display: inline-block;
  margin: 0 8px 0 0;
  ~ .user-info-input {
    width: 20%;
  }
}
.email-error {
  color: #ff0000;
}

.user-info-input {
  border: none !important;
  height: 32px !important;
  min-width: 20% !important;
  /*padding: 0 8px!important;*/
  display: inline-block;
  width: 100%;
  vertical-align: middle;
  outline:none;
}

.del-selected-user {
  cursor: pointer;
}
</style>
